import {history} from '../store/index';
import {store} from '../../NextApp';
import {generateQueryString} from "../../util/Api";

import {
  CREATE_TPW_SUCCESS,
  FETCH_ACTIVITY_SNO_SUCCESS,
  FETCH_TPW_SUCCESS,
  GET_TPW_SUCCESS,
  SAVE_TPW_QUERY,
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import {fetchError, fetchFilter, fetchStart, fetchSuccess} from "./Common";
import {message} from "antd";
import {arrayToCSV, downloadCSV} from "../../util/methods";
import Swal from "sweetalert2";


export const getResourceSuccess = ({data, count}) => {
  return {
    type: GET_TPW_SUCCESS,
    data,
    count
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_TPW_QUERY,
    query
  };
};

export const createResourceSuccess = ({data}) => {
  return {
    type: CREATE_TPW_SUCCESS,
    data
  };
};

export const fetchResourceSuccess = ({data}) => {
  return {
    type: FETCH_TPW_SUCCESS,
    data
  };
};

export const fetchActivityResourceSuccess = (data) => {
  return {
    type: FETCH_ACTIVITY_SNO_SUCCESS,
    data
  };
};

export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {thirdPartyWorkRequirement} = store.getState();
      const {query} = thirdPartyWorkRequirement;
      const response = await axios.get(`/third-party-work-requirement?${generateQueryString(query)}`);

      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {thirdPartyWorkRequirement} = store.getState();
      const {query} = thirdPartyWorkRequirement;
      const response = await axios.get(`/third-party-work-requirement/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns)
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const createResource = (payload, redirect = true, module) => {
  return async (dispatch) => {
      dispatch(fetchStart());
    try {
      const response = await axios.post(`/third-party-work-requirement`, payload);
      dispatch(fetchSuccess());
      dispatch(createResourceSuccess(response.data));
      const tpwData = response.data;
      let htmlData = '';
      await tpwData && tpwData.activitySerialNo && tpwData.activitySerialNo.map((item, index ) => {
        htmlData += `<div style="text-align: left; border: 1px solid #000000; margin-bottom: 5px; padding: 10px; ${index === 0 ? 'margin-top: 20px' : ''} ">
       TPW IS CREATED AGAINST THE ACTIVITY NUMBER - ${item} <br> TPWCode -${tpwData['tpwNo']}</div>`
      });

      tpwData && tpwData['activitySerialNo'] && tpwData['activitySerialNo'].length && Swal.fire({
        width: 900,
        background: '#fff',
        backdrop: `
          rgba(0,0,123,0.4)
          left top
          no-repeat
        `,
        textAlign: 'left',
        text: 'Tpw List',
        showCloseButton: true,
        html: htmlData,
      });
      if (!redirect) {
        dispatch(fetchFilter(module));
      } else {
        history.push('/third-party-work-requirement');
        dispatch(getResource());
      }
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const fetchResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/third-party-work-requirement/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({data: response.data}));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const fetchActivitySno = () => {
  return async (dispatch) => {
    dispatch(fetchStart());

    try {
      const response = await axios.get(`/third-party-work-requirement/activity`);
      dispatch(fetchSuccess());
      dispatch(fetchActivityResourceSuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};
